module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-6-fill-876031ca.svg";